import Vue from 'vue';

import realImg from './real-img';

const directives = {
    "real-img": realImg,
}

const install = function (Vue) {
    for (let key in directives) {
        Vue.directive(key, directives[key]);
    }
}

Vue.use(install);